"use client";
import {
  createDisclosureStore
} from "./43IPP2F4.js";

// src/dialog/dialog-store.ts
function createDialogStore(props = {}) {
  return createDisclosureStore(props);
}

export {
  createDialogStore
};
